import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_USERS } from "./apiRoutes";

interface mutateProps {
  userId: number;
  active: boolean;
}
const mutateUpdateUserActive = async ({ userId, active }: mutateProps) => {
  return await axiosAuth.patch(`${GET_USERS}/${userId}/active`, null, {
    params: { active },
  });
};

const useUpdateUserActiveMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateUpdateUserActive,
    ...queryParams,
  });

export default useUpdateUserActiveMutation;
